
define('css!ui/animable/absorbable/css/absorb',[],function(){});
